import { runInAction } from 'mobx';
import { LoadingState } from '../../../types/loading-state';
import { browsingDomainStore } from '../../browsing/store';
import { filterDomainStore } from '../store';
import { FilterType } from '../types/filter-type';
export function getFilterByIdAndType(id, filterType) {
    switch (filterType) {
        case FilterType.Film:
            return getFilmFilter(id);
        case FilterType.Showtime:
            return filterDomainStore.data.showtimeFilters[id];
        case FilterType.Subscription:
            return filterDomainStore.data.subscriptionFilters[id];
        default:
            return;
    }
}
export const getFilmFilter = (id) => {
    const filter = filterDomainStore.data.filmFilters[id];
    if (!filter)
        return undefined;
    const { loadingState } = filter.siteId
        ? browsingDomainStore.data.filmIdsBySiteId[filter.siteId]
        : browsingDomainStore.data.allFilmIds;
    // Clear the filter if its source data has been reset.
    if (loadingState === LoadingState.NotLoaded) {
        runInAction(() => {
            delete filterDomainStore.data.filmFilters[id];
        });
        return undefined;
    }
    return filterDomainStore.data.filmFilters[id];
};
